import { connect } from 'react-redux';
import Login from '../components/Login';
import {
  getPassword,
  getTenants,
  getUsername,
  isAuthenticated,
  isLoggingIn,
} from '../reducers/analyticsApp';
import { changePassword, changeUsername, login } from '../actions/login';
import { setTenantId } from '../actions/project';

const mapStateToProps = (state) => ({
  username: getUsername(state),
  password: getPassword(state),
  loggingIn: isLoggingIn(state),
  authenticated: isAuthenticated(state),
  tenants: getTenants(state),
});

export default connect(mapStateToProps, {
  onChangeUsername: changeUsername,
  onChangePassword: changePassword,
  onSubmit: login,
  setTenantId,
})(Login);
